module.exports = __webpack_public_path__ + "fonts/HalisR-S-Thin.2df6458b.otf";